import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import './Reports.css';

type Health = {
  counts: Record<string, number>;
  known_classifications: number;
  open_classification_issues: Array<{ id: number; identifier: string; instrument_type: string; message: string; created_at: string }>;
  failures: Array<{ id: string; report_type: string; owner_id: number; attempts: number; error: string; created_at: string }>;
};

const SuperAdminReports: React.FC = () => {
  const [health, setHealth] = useState<Health | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API_BASE_URL}/reports/admin/health/`)
      .then(response => setHealth(response.data))
      .catch(() => setError('Report health data could not be loaded.'));
  }, []);

  return <div className="reports-page reports-admin-page">
    <header className="reports-hero reports-admin-hero"><div><p className="reports-eyebrow">SUPERADMIN OPERATIONS</p><h1>Report generation health</h1><p>Operational metadata only. User report contents remain private.</p></div></header>
    {error && <div className="reports-error">{error}</div>}
    {health && <>
      <section className="report-metrics reports-admin-metrics">
        {['queued', 'processing', 'ready', 'failed'].map(key => <div className="report-metric" key={key}><span>{key}</span><strong>{health.counts[key] || 0}</strong><small>report jobs</small></div>)}
      </section>
      <div className="reports-admin-grid">
        <section className="reports-detail-card"><div className="reports-chart-title"><div><small>CLASSIFICATION QUEUE</small><h3>Open user reports</h3></div><strong>{health.open_classification_issues.length}</strong></div>
          {health.open_classification_issues.length === 0 ? <div className="reports-empty">No classification issues are waiting.</div> : health.open_classification_issues.map(issue => <div className="admin-health-row" key={issue.id}><strong>{issue.identifier}</strong><span>{issue.instrument_type}</span><p>{issue.message}</p></div>)}
        </section>
        <section className="reports-detail-card"><div className="reports-chart-title"><div><small>FAILURE QUEUE</small><h3>Exports needing attention</h3></div><strong>{health.failures.length}</strong></div>
          {health.failures.length === 0 ? <div className="reports-empty">No failed report jobs.</div> : health.failures.map(failure => <div className="admin-health-row" key={failure.id}><strong>{failure.report_type}</strong><span>Owner #{failure.owner_id} / attempt {failure.attempts}</span><p>{failure.error}</p></div>)}
        </section>
      </div>
      <p className="reports-admin-note">{health.known_classifications} instrument classifications are currently versioned. Corrections and reasons are managed in Django administration.</p>
    </>}
  </div>;
};

export default SuperAdminReports;
